import React from 'react';
import { Check } from 'lucide-react';
import { portfolioData } from '../mock';

const About = () => {
  const trustPoints = [
    "Persönlicher Ansprechpartner",
    "Lokal in Kelsterbach",
    "Schnelle Umsetzung",
    "Faire Preise"
  ];

  return (
    <section id="about" className="py-20 px-6 lg:px-8 bg-[#F1F5F9]">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-4xl">
          <h2 className="text-5xl sm:text-6xl font-bold text-black mb-16">
            {portfolioData.about.title}
          </h2>

          <div className="space-y-8 mb-12">
            {portfolioData.about.paragraphs.map((paragraph, index) => (
              <p key={index} className="text-xl text-gray-600 leading-relaxed">
                {paragraph}
              </p>
            ))}
          </div>

          {/* Warum WebWerk - Trust Points */}
          <div className="mt-16">
            <h3 className="text-2xl font-bold text-black mb-8">Warum WebWerk?</h3>
            <div className="grid sm:grid-cols-2 gap-4">
              {trustPoints.map((point, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-6 h-6 bg-[#1E40AF] rounded-full flex items-center justify-center">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-lg text-gray-700 font-medium">{point}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;